import { render, staticRenderFns } from "./SdsProduct.vue?vue&type=template&id=5d4d6882&"
import script from "./SdsProduct.vue?vue&type=script&lang=js&"
export * from "./SdsProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports